module.exports = __webpack_public_path__ + "static/media/ng.4250915a.svg";